import "./Inductions.css";
import NavBar from "../Components/NavBar";
import Status_Pop from "../Components/Status_Pop";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function Inductions()
{
    useEffect(() => {
        setRoll(window.sessionStorage.getItem("roll"));
        setName(window.sessionStorage.getItem("name"));
        setPhone(window.sessionStorage.getItem("phone"));
        
    }, []);

    const [email, setEmail] = useState("");
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [roll, setRoll] = useState("");
    const [department, setDepartment] = useState("CSE");
    const [response_01, setResponse_01] = useState("");
    const [response_02, setResponse_02] = useState("");
    const [response_03, setResponse_03] = useState("");
    const [response_04, setResponse_04] = useState("");

    const nav = useNavigate();

    const departmentID = {
        'CSE' : 1,
        'ECE' : 2,
        'EEE' : 3,
        'ICE' : 4,
        'Mech' : 5,
        'Prod' : 6,
        'Chem' : 7,
        'MME' : 8,
        'Civil' : 8,
        'Archi' : 9
    };

    function handleEmailChange(e)
    {
        setEmail(e.target.value);
    }

    function handleNameChange(e)
    {
        setName(e.target.value);
    }

    function handlePhoneChange(e)
    {
        setPhone(e.target.value);
    }

    function handleDepartmentChange(e)
    {
        setDepartment(e.target.value);
    }

    function handleResponseChange_01(e)
    {
        setResponse_01(e.target.value);
    }

    function handleResponseChange_02(e)
    {
        setResponse_02(e.target.value);
    }

    function handleResponseChange_03(e)
    {
        setResponse_03(e.target.value);
    }

    function handleResponseChange_04(e)
    {
        setResponse_04(e.target.value);
    }

    function redirect()
    {
        window.location.href = "https://favprod.raganindustries.com";
    }

    function submitResponse()
    {
        let url = "https://favapis.raganindustries.com/api_create_induction_response.php";
        let headers = {
            "Accept" : "application/json",
            "Content-type" : "application/json"
        };
        let values = {
            inductee_roll : roll,
            inductee_name : name,
            inductee_department : departmentID[department],
            inductee_phone : phone,
            inductee_email : email,
            inductee_response_01 : response_01,
            inductee_response_02 : response_02,
            inductee_response_03 : response_03,
            inductee_response_04 : response_04
        };
        fetch(url, {
            method : 'POST',
            headers : headers,
            body : JSON.stringify(values)
        }).then((response) => response.json()).then((data) => {
            console.log(data);
            Status_Pop({ status : data.status, redirect : redirect });
        })
    }

    return(
        <div className = "inductions">
            <NavBar />
            <div className = "registration_form">
                <br/><br/><br/>
                <div className = "consent_form">
                    <h1>Festember Audio Visuals</h1>
                    <p>
                    Join us in a dynamic role where you'll enhance your management skills, collaborate with top-tier vendors, and gain invaluable experience in event organisation.  Seize the opportunity to troubleshoot live challenges, lead with creativity, and make a lasting impact.
                    <br/><br/>
                    Don't miss out on the chance to light up events and make memories that last a lifetime. Apply NOW!
                    <br/><br/>
                    <span>We would access your webmail ID, name and phone number from DAuth. We assure that all these information are secured and we are liable for your personal data</span>
                    </p>
                </div>
                <br/>
                <div className = "input_field">
                    <h1>Personal Email ID</h1>
                    <br/>
                    <input type = "text" placeholder = "Enter email" value = { email } onChange = { handleEmailChange } />
                    <div className = "border"></div>
                </div>
                <br/>
                <div className = "input_field">
                    <h1>Name</h1>
                    <br/>
                    <input type = "text" placeholder = "Enter name" value = { name } onChange = { handleNameChange } />
                    <div className = "border"></div>
                </div>
                <br/>
                <div className = "input_field">
                    <h1>Phone number</h1>
                    <br/>
                    <input type = "text" placeholder = "Enter phone number" value = { phone } onChange = { handlePhoneChange } />
                    <div className = "border"></div>
                </div>
                <br/>
                <div className = "input_field">
                    <h1>Roll number</h1>
                    <br/>
                    <input type = "text" placeholder = "Enter roll number" value = { roll } />
                    <div className = "border"></div>
                </div>
                <br/>
                <div className = "input_field">
                    <h1>Department</h1>
                    <br/>
                    <select onChange = { handleDepartmentChange }>
                        <option value = "CSE">CSE</option>
                        <option value = "ECE">ECE</option>
                        <option value = "EEE">EEE</option>
                        <option value = "ICE">ICE</option>
                        <option value = "Mech">Mech</option>
                        <option value = "Prod">Prod</option>
                        <option value = "Chem">Chem</option>
                        <option value = "MME">MME</option>
                        <option value = "Civil">Civil</option>
                        <option value = "Archi">Archi</option>
                    </select>
                </div>
                <br/>
                <div className = "input_field">
                    <h1>According to you, What does Audio Visuals Team do?</h1>
                    <br/>
                    <textarea placeholder = "Enter your response" value = { response_01 } onChange = { handleResponseChange_01 } ></textarea>
                    <div className = "border"></div>
                </div>
                <br/>
                <div className = "input_field">
                    <h1>According to you, What does Audio Visuals Team do?</h1>
                    <br/>
                    <textarea placeholder = "Enter your response" value = { response_02 } onChange = { handleResponseChange_02 } ></textarea>
                    <div className = "border"></div>
                </div>
                <br/>
                <div className = "input_field">
                    <h1>If you could remove one superhero from the Avengers who would it be ? Give reason</h1>
                    <br/>
                    <textarea placeholder = "Enter your response" value = { response_03 } onChange = { handleResponseChange_03 } ></textarea>
                    <div className = "border"></div>
                </div>
                <br/>
                <div className = "input_field">
                    <h1>What do you expect to learn from FAV ?</h1>
                    <br/>
                    <textarea placeholder = "Enter your response" value = { response_04 } onChange = { handleResponseChange_04 } ></textarea>
                    <div className = "border"></div>
                </div>
                <br/>
                <button className = "submit" onClick = { submitResponse } >Submit</button>
                <br/><br/>
            </div>
            <br/><br/><br/>
        </div>
    );
}

export default Inductions;